import React from "react";
import { ContentBlock, T } from '../uikit-b2c/uikit-b2c';
import { Svg } from "../uikit-b2c/Svg";
import { Ffr } from './Ffr';
import styled, { css, ThemeProvider } from "styled-components";

export default function PSfooter({
  theme
}) {
  return (
    <div
      style={{
        color: theme['colorText'],
        padding: '16px 0',
        display: 'grid',
        // gridTemplateColumns: '1fr 1fr',
        gridColumnGap: 24,
        // gridRowGap: 24,
      }}
    >
{/*
      <ContentBlock appearance="flatten">
        <Ffr/>
      </ContentBlock> */}

      <CssFooter0>


        <div>
          <div>
            <T opacity={0.6} xs>
            Xsolla is an authorized video game software distributor providing clients with advanced technical tools for their games
            </T>
          </div>
        </div>

        <div>
          <T opacity={0.6} xs>
            <div style={{width: 160, display: 'grid', gridTemplateColumns: '1fr 24px', gridColumnGap: 8}}>
              <div>
              © 2006-2020 Xsolla<br/>
              Secure Connection
              </div>
              <Svg
                style={{marginTop: 4}}
                width={24}
                height={24}
                color={theme['colorText']}>{psShield}
              </Svg>
            </div>
          </T>
        </div>



    </CssFooter0>


          <CssFooterLinks>
              <T opacity={0.6} xs >
                <a href='#'
                  style={{color: theme['colorAccent']}}
                >Privacy Policy</a>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <a
                style={{color: theme['colorAccent']}}
                href='#'>End User License Agreement</a>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <a
                style={{color: theme['colorAccent']}}
                href='#'>Refund Policy</a>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <a
                style={{color: theme['colorAccent']}}
                href='#'>Cookie Policy</a>
              </T>
          </CssFooterLinks>

      </div>

  );
}


const CssFooter0 = styled.div`
  display: grid;
  grid-template-columns: 1fr 160px;
  grid-column-gap: 44px;
`
const CssFooterLinks = styled.div`
  padding: 10px 0 0 0;
  display: flex;
  /* justify-content: center; */
`



export const psShield = `<svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M53.6032 18.1555H51.374V20.3847H49.1448V22.614H46.9155V24.8432H44.6863V27.0724H42.4571V29.3016H40.2279V31.5308H37.9987V33.76H35.7695V35.9892H33.5403V38.2184H31.3111V40.4476H29.0819V42.6768H26.8526V44.9061H24.6234V51.5937H29.0819V49.3645H31.3111V47.1353H33.5403V44.9061H35.7695V42.6768H37.9987V40.4476H40.2279V38.2184H42.4571V35.9892H44.6863V33.76H46.9155V31.5308H49.1448V29.3016H51.374V27.0724H53.6032V24.8432H55.8324V22.614H58.0616V15.9263H53.6032V18.1555ZM22.3942 67.1982H15.7066V60.5105H11.2482V56.0521H6.78976V51.5937H4.56055V4.78027H71.4369V51.5937H69.2076V56.0521H64.7492V60.5105H60.2908V67.1982H53.6032V71.6566H22.3942V67.1982ZM9.01897 9.23869V11.4679H66.9784V9.23869H9.01897ZM9.01897 11.4679V42.6768H11.2482V11.4679H9.01897ZM64.7492 11.4679V42.6768H66.9784V11.4679H64.7492ZM9.01897 42.6768V47.1353H11.2482V42.6768H9.01897ZM15.7066 49.3645V56.0521H17.9358V49.3645H15.7066ZM26.8526 60.5105V67.1982H29.0819V60.5105H26.8526ZM46.9155 60.5105V67.1982H49.1448V60.5105H46.9155ZM29.0819 64.969V67.1982H46.9155V64.969H29.0819ZM20.165 53.8229V62.7397H22.3942V53.8229H20.165ZM53.6032 53.8229V62.7397H55.8324V53.8229H53.6032ZM58.0616 49.3645V56.0521H60.2908V49.3645H58.0616ZM64.7492 42.6768V47.1353H66.9784V42.6768H64.7492ZM11.2482 49.3645V51.5937H15.7066V49.3645H11.2482ZM17.9358 53.8229V56.0521H20.165V53.8229H17.9358ZM11.2482 44.9061V49.3645H13.4774V44.9061H11.2482ZM62.52 44.9061V49.3645H64.7492V44.9061H62.52ZM55.8324 53.8229V56.0521H58.0616V53.8229H55.8324ZM60.2908 49.3645V51.5937H64.7492V49.3645H60.2908ZM22.3942 60.5105V62.7397H26.8526V60.5105H22.3942ZM49.1448 60.5105V62.7397H53.6032V60.5105H49.1448Z" fill="#0073f7"></path>
</svg>`